export default "__VITE_ASSET__BwiJmSAR__"